/* BBF Products — tab switching + AJAX add to cart */
(function () {

  var plusContent = '<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="7" y1="1" x2="7" y2="13"/><line x1="1" y1="7" x2="13" y2="7"/></svg>';
  var checkContent = '<svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="1,7 5,11 13,3"/></svg>';

  /* ---- Tab switching ---- */
  document.querySelectorAll('.bbf-products').forEach(function (section) {
    var tabs   = section.querySelectorAll('.bbf-products__tab');
    var panels = section.querySelectorAll('.bbf-products__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.dataset.tab;
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        var panel = section.querySelector('[data-panel="' + target + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  });

  /* ---- Add to cart — delegate on document to catch all cards ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bbf-product-card__atc');
    if (!btn) return;

    var variantId = parseInt(btn.dataset.variantId, 10);
    if (!variantId) return;

    /* Prevent double-clicks */
    if (btn.classList.contains('is-loading')) return;

    btn.classList.add('is-loading');
    btn.innerHTML = '<span style="display:inline-block;width:12px;height:12px;border:2px solid rgba(255,255,255,0.4);border-top-color:#fff;border-radius:50%;animation:bbf-spin 0.6s linear infinite;"></span>';

    /* Safety reset: the external cart app can swallow the /cart/add.js request
       so our promise never settles — never leave the button stuck on the spinner. */
    var settled = false;
    var safety = setTimeout(function () {
      if (settled) return;
      btn.classList.remove('is-loading');
      btn.innerHTML = plusContent;
      btn.style.background = '';
      document.dispatchEvent(new CustomEvent('bbf:cart:updated'));
    }, 2200);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (err) { throw new Error(err.description || 'Cart error'); });
      }
      return response.json();
    })
    .then(function () {
      /* Success — show checkmark */
      settled = true; clearTimeout(safety);
      btn.classList.remove('is-loading');
      btn.innerHTML = checkContent;
      btn.style.background = '#2a7a2a';

      /* Fire cart updated event */
      document.dispatchEvent(new CustomEvent('bbf:cart:updated'));

      /* Reset button after 1.8s */
      setTimeout(function () {
        btn.innerHTML = plusContent;
        btn.style.background = '';
      }, 1800);

      return Promise.resolve();
    })
    .catch(function (err) {
      settled = true; clearTimeout(safety);
      btn.classList.remove('is-loading');
      btn.innerHTML = plusContent;
      btn.style.background = '#8B0000';
      setTimeout(function () { btn.style.background = ''; }, 1500);
      console.warn('BBF ATC error:', err.message);
    });
  });

  /* Spinner keyframe */
  var style = document.createElement('style');
  style.textContent = '@keyframes bbf-spin { to { transform: rotate(360deg); } }';
  document.head.appendChild(style);

})();
